<template>
	<div :class="classes">
		<template v-if="dropdown">
			<a
				:href="'#' + id"
				class="Toolbar-item-button"
				data-toolbar-toggler
				:data-toolbar-toggler-expanded="dropdownActive"
				:aria-expanded="dropdownActive ? true : 'false'"
				@click.prevent="toggleDropdown"
			>
				<CloIcon v-if="icon" :symbol="icon" />
				<span class="Toolbar-item-label">{{ label }}</span>
				<CloIcon symbol="triangleDown" />
			</a>
			<div :id="id" class="Toolbar-item-dropdown" :class="dropdownClasses" :aria-hidden="dropdownActive ? 'false' : true">
				<!-- @slot for the toolbar item dropdown-->
				<slot />
			</div>
		</template>

		<template v-else-if="href">
			<a :href="href" class="Toolbar-item-button Toolbar-item-button-label">
				<CloIcon v-if="previous" symbol="arrowLeft" />
				<CloIcon v-if="icon" :symbol="icon" />
				<span>{{ label }}</span>
				<CloIcon v-if="next" symbol="arrowRight" />
			</a>
		</template>

		<template v-else>{{ label }}</template>
	</div>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
export default {
	components: { CloIcon },
	name: 'CloToolbarItem',
	data() {
		return {
			dropdownActive: false,
		};
	},
	props: {
		/**
		 * unique id
		 */
		id: {
			type: String,
			default: 'id-' + Math.random().toString(36).substr(2, 9),
		},
		href: String,
		label: String,
		dropdown: Boolean,
		icon: String,
		next: Boolean,
		previous: Boolean,
		align: String,
		divider: Boolean,
		closeDropdownIncrement: Number,
		fill: Boolean,
		reverse: Boolean,
		hideLabel: Boolean,
		allowOverflow: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		closeDropdownIncrement() {
			this.dropdownActive = false;
		},
	},
	computed: {
		classes: function () {
			let classes = [];
			if (this.dropdown) {
				classes.push('Toolbar-item');
				classes.push('Toolbar-item--hasDropdown');
			} else if (this.href) {
				classes.push('Toolbar-item');
			} else {
				classes.push('Toolbar-label');
			}
			if (this.divider) {
				classes.push('Toolbar-item--divider');
			}
			if (this.hideLabel) {
				classes.push('Toolbar-item--hideLabel');
			}
			if (this.fill) {
				classes.push('Toolbar-item--hasDropdownFill');
			}
			return classes.join(' ');
		},
		dropdownClasses: function () {
			let classes = [];
			if (this.align === 'right') {
				classes.push('Toolbar-item-dropdown--right');
			}
			if (this.fill) {
				classes.push('Toolbar-item-dropdown--fill');
			}
			if (this.reverse) {
				classes.push('Toolbar-item-dropdown--reverse');
			}
			if (this.allowOverflow) {
				classes.push('Toolbar-item-dropdown--overflow');
			}
			return classes.join(' ');
		},
	},
	mounted() {
		window.document.addEventListener('click', this.clickAnywhere);
	},
	beforeDestory() {
		window.document.removeEventListener('click', this.clickAnywhere);
	},
	methods: {
		toggleDropdown() {
			this.dropdownActive = !this.dropdownActive;
		},
		clickAnywhere(e) {
			if (!this.$el.contains(e.target)) {
				this.dropdownActive = false;
			}
		},
	},
};
</script>
